export default "__VITE_ASSET__Ct_Qz$o2__"